import script from "./AudioControlsGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioControlsGroup.vue?vue&type=script&setup=true&lang=js"

import "./AudioControlsGroup.vue?vue&type=style&index=0&id=0fc9a04e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc9a04e"]])

export default __exports__